import { useEffect } from "react";

const DatabaseModel = () => {
  // useEffect(() => { window.location.replace('http://128.199.217.7/') }, [])
  useEffect(() => {
    window.open("http://128.199.217.7/", "_blank");
  }, []);
  return <div>DatabaseModel</div>;
};

export default DatabaseModel;
